export default __webpack_public_path__ + "static/media/plant1.8e77684f.PNG";